export default "__VITE_ASSET__f63d23f6__"